import { Link } from 'react-router-dom';
import { BookOpen, GraduationCap, Layers } from 'lucide-react';

import { cn } from 'lib/utils';
import { courseBuilderHref, moduleBuilderHref, questionLibraryHref } from './contentToolLinks';

export type ContentTool = 'question-library' | 'module-builder' | 'course-builder';

const TOOLS: { tool: ContentTool; label: string; icon: typeof BookOpen; href: (courseId: number) => string }[] = [
  { tool: 'question-library', label: 'Question Library', icon: BookOpen, href: courseId => questionLibraryHref({ courseId }) },
  { tool: 'module-builder', label: 'Module Builder', icon: Layers, href: courseId => moduleBuilderHref({ courseId }) },
  { tool: 'course-builder', label: 'Course Builder', icon: GraduationCap, href: courseBuilderHref },
];

/** "Open this course in" links to the other two content builders, on the same course. */
export default function CourseJumpLinks({ courseId, current, className }: { courseId: number; current: ContentTool; className?: string }) {
  return (
    <p className={cn('flex flex-wrap items-center gap-x-3 gap-y-1 text-xs text-muted-foreground', className)} data-testid="course-jump-links">
      <span>Open this course in</span>
      {TOOLS.filter(item => item.tool !== current).map(({ tool, label, icon: Icon, href }) => (
        <Link
          key={tool}
          to={href(courseId)}
          className="inline-flex items-center gap-1 font-medium text-foreground underline-offset-2 hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary"
        >
          <Icon className="h-3.5 w-3.5" aria-hidden="true" />{label}
        </Link>
      ))}
    </p>
  );
}
